import React, { Component } from 'react'
import { withHandlers } from 'recompose'

import { Textarea } from 'components/Utils/Form'
import { Text } from 'components/base'

export const MAX_INVITEES = 50

const enhance = withHandlers({
  setInviteBulkText: ({ setInviteBulkText }) => event => {
    const text = event.target.value

    setInviteBulkText(
      text
        .split(',')
        .slice(0, MAX_INVITEES)
        .join(',')
    )
  },
})

class BulkInvitationsForm extends Component {
  render() {
    const { goBack, inviteBulkText, setInviteBulkText } = this.props
    return (
      <div>
        <Textarea
          autoFocus
          onChange={setInviteBulkText}
          placeholder="joe@acme.com, alinda@acme.com, giorgio@acme.com"
          value={inviteBulkText}
        />
        <div className="font-size-smaller shade-20 text-align-right">
          Copy & paste a list of contacts. Please separate each address with a
          comma.
        </div>
        <div className="margin-vertical-normal">
          <Text.Action
            href=""
            onClick={event => {
              event.preventDefault()
              goBack()
            }}
          >
            {'Back to single invitation'}
          </Text.Action>
        </div>
      </div>
    )
  }
}

export default enhance(BulkInvitationsForm)
